import { FC, ElementType } from 'react';
import { Typography, TypographyProps } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

interface DeloitteTextProps extends TypographyProps {
    text?: string;
    component?: ElementType;
}
const useStyles = makeStyles((theme) => ({
    text: {
        fontWeight: 300,
        fontSize: '20px',
        color: theme.palette.text.secondary,
        lineHeight: 1.6,
        marginBottom: 16
    }
}));
export const DeloitteText: FC<DeloitteTextProps> = (props) => {
    const { text, children, component, className } = props;
    const classes = useStyles();
    return (
        <Typography className={className ?? classes.text} component={component ?? "p"}>{text}{children}</Typography>
    );
}